import React from 'react';
import { Link } from 'react-router-dom';

const LandingFooter: React.FC = () => {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        <Link to="/" className="landing-footer__logo">
          <svg
            className="landing-footer__logo-mark"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <circle cx="12" cy="12" r="12" fill="#1e293b" />
            <circle cx="12" cy="12" r="3.5" fill="#2563eb" />
          </svg>
          <span>Map of Projects</span>
        </Link>
        <p className="landing-footer__copy">
          &copy; {new Date().getFullYear()} Map of Projects. All rights reserved.
        </p>
        <div className="landing-footer__links">
          <Link to="/for/solar">For solar</Link>
          <Link to="/for/trades">For trades</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/login">Log in</Link>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
